export const BRAND = "Cagatay Turna";
export const BRAND_SUB = "Yatırım ve İnşaat";

// Hero/nav CTA — Kurumsal İş Yönetimi platformuna giriş için login sayfasına yönlendirir.
export const LOGIN_HREF = "/login";

export const NAV_LINKS = [
  { label: "Hakkımda", href: "#hakkimda" },
  { label: "Uzmanlık", href: "#uzmanlik" },
  { label: "Yayınlarım", href: "#yayinlar" },
  { label: "İletişim", href: "#iletisim" },
];

// Hero media. Drop a video into /public and set HERO_VIDEO_SRC to activate
// scroll-scrubbed video; null keeps the cinematic image hero (portrait).
export const HERO_VIDEO_SRC = null;
export const HERO_PORTRAIT = "/assets/portrait.jpg";

export const HERO_STATES = [
  {
    overline: "Cagatay Turna · İnşaat Yüksek Mühendisi",
    title: "Yatırım ve\nİnşaat",
    line: "Proje yönetimi, ihale süreçleri, yapı denetimi ve kurumsal iş takibinde uzmanlık.",
  },
  {
    overline: "Kurumsal İş Yönetimi",
    title: "Süreçler\ntek ekranda.",
    line: "Dağınık takip yerine; planlı, izlenebilir ve şeffaf bir kurumsal iş akışı.",
  },
  {
    overline: "Yaklaşım",
    title: "Güvenli.\nİzlenebilir.",
    line: "Rol bazlı erişim, dijital arşiv ve gerçek zamanlı hatırlatmalarla kurumsal hafıza.",
  },
];

// Hakkımda — gerçek künye (cagatayturna.com / Hakkımda)
export const ABOUT_BIO = [
  "Yatırım ve inşaat sektöründe deneyime sahip bir İnşaat Yüksek Mühendisiyim. Proje yönetimi, ihale süreçleri, yapı denetimi ve kurumsal iş takibi konularında uzmanlaşmış bulunmaktayım.",
  "İstanbul Gençlik ve Spor İl Müdürlüğü Yatırım ve İnşaat Şube Müdürlüğünde çalışmaktayım. İstanbul Arel Üniversitesinde İnşaat Mühendisliği üzerine Deprem Mühendisliği alanında Doktora eğitimime devam etmekteyim.",
];

export const CREDENTIALS = [
  { value: "18+", label: "Yıl Deneyim" },
  { value: "5", label: "Akademik Yayın" },
  { value: "10+", label: "Ekip Üyesi" },
];

export const EDUCATION = [
  { period: "2023 – Devam", title: "Doktora — İnşaat Mühendisliği", place: "İstanbul Arel Üniversitesi" },
  { period: "2019 – 2021", title: "Yüksek Lisans (Tezli) — İnşaat Müh. (3.94/4)", place: "İstanbul Aydın Üniversitesi" },
  { period: "2003 – 2007", title: "Lisans — İnşaat Mühendisliği", place: "Dumlupınar Üniversitesi" },
];

export const SOFTWARE = [
  "SAP2000", "ETABS", "Prota Structure", "ideCAD", "AutoCAD",
  "MS Office (İleri)", "OSKA/AMP Hakediş", "Nivo", "XTRACT",
];

// Uzmanlık Alanları (gerçek içerik)
export const EXPERTISE = [
  {
    tag: "Yapı Denetimi ve Kontrollük",
    desc: "Spor tesisleri, yurt binaları ve kamu yapılarının kontrollüğü ve iş programı takibi.",
    image: "https://images.unsplash.com/photo-1770152626339-f55625a4c141?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    tag: "İhale ve Mevzuat",
    desc: "4734 sayılı KİK, yapım ihaleleri, hakediş, yaklaşık maliyet ve sözleşme yönetimi.",
    image: "https://images.unsplash.com/photo-1772442198624-4fc4d7281e89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    tag: "Deprem Performans Analizi",
    desc: "TBDY 2018 kapsamında mevcut yapıların performans değerlendirmesi ve güçlendirme.",
    image: "https://images.unsplash.com/photo-1662647326416-7f7bc8f86eef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    tag: "Dijital Dönüşüm",
    desc: "İş süreçlerinin dijitalleştirilmesi ve Kurumsal İş Yönetimi Platformu geliştirme.",
    image: "https://images.unsplash.com/photo-1465447142348-e9952c393450?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

// Kurumsal İş Yönetimi Platformu modülleri (platform üzerindeki tüm modüller)
export const MODULES = [
  { no: "01", icon: "gavel",    title: "İhaleler · Ödenek · Hakediş", desc: "İhale süreçleri, ödenek takibi ve hakediş onayları tek akışta yönetilir." },
  { no: "02", icon: "wrench",   title: "Bakım & Onarım",              desc: "Tesis bakımı, arıza ve onarım taleplerinin uçtan uca takibi." },
  { no: "03", icon: "shield",   title: "Periyodik Kontrol",           desc: "Ekipman muayene, kontrol raporları ve SLA uyumluluğunun otomatik takibi." },
  { no: "04", icon: "land",     title: "Emlak & Kamulaştırma",        desc: "Taşınmaz envanteri, tahsis, kira ve kamulaştırma kayıtlarının izlenmesi." },
  { no: "05", icon: "map",      title: "Harita & Lokasyon",           desc: "Tüm taşınmaz ve şantiyelerin harita üzerinde görsel takibi." },
  { no: "06", icon: "hardhat",  title: "Şantiye Takip",               desc: "Yer teslimi, geçici/kesin kabuller ve şantiye saha kayıtları." },
  { no: "07", icon: "shopping", title: "Doğrudan Temin",              desc: "4734/22-d kapsamındaki alımların talep, teklif ve hakediş süreci." },
  { no: "08", icon: "building", title: "Firma & Yüklenici",           desc: "Yüklenici, taşeron ve hizmet alım firmalarının tek elden yönetimi." },
  { no: "09", icon: "tasks",    title: "Görevler & Takvim",           desc: "Görev atama, son tarih ve hatırlatmalarla planlı iş takibi." },
  { no: "10", icon: "archive",  title: "Arşiv & Belge Yönetimi",      desc: "Tüm yazışma ve belgelerin güvenli, aranabilir dijital arşivi." },
  { no: "11", icon: "chart",    title: "Grafikler & Raporlama",       desc: "Gerçek zamanlı göstergeler ve yönetime özel raporlar." },
  { no: "12", icon: "users",    title: "Kullanıcılar & Yetki",        desc: "Rol bazlı erişim ve ayrıntılı kullanıcı yetkilendirme." },
  { no: "13", icon: "bell",     title: "Bildirim & Hatırlatma",       desc: "Yaklaşan süreler, SLA ihlali ve garanti bitişlerinde aktif uyarılar." },
];

// Yayınlarım (gerçek liste — cagatayturna.com / Yayınlarım)
export const PUBLICATIONS = [
  {
    year: "2020", type: "Makale",
    title: "Türkiye Bina Deprem Yönetmeliğine Göre Mevcut Betonarme Binanın Performansının ve Zemin Etkileşiminin Değerlendirilmesi",
    venue: "Bilecik Şeyh Edebali Üniversitesi Fen Bilimleri Dergisi, 7(2), 1004–1014",
    doi: "10.35193/bseufbd.727437",
  },
  {
    year: "2021", type: "Kongre",
    title: "Farklı Kat Adetlerine Sahip Betonarme Yapıların Doğrusal Olmayan Statik İtme Analizine Göre Tasarım Sonuçlarının TBDY 2019 Kapsamında Değerlendirilmesi",
    venue: "Uluslararası Mühendislik ve Doğa Bilimleri Çalışmaları Kongresi (ICENSS2021)",
    doi: "",
  },
  {
    year: "2021", type: "Makale",
    title: "Evaluation of The Performance of An Existing Reinforced Concrete Grandstand According to TBDY 2019",
    venue: "MAS Journal of Applied Sciences, 6(2), 433–445",
    doi: "10.52520/masjaps.77",
  },
  {
    year: "2021", type: "Makale",
    title: "Comparison of Contract Types for Turnkey Lump Sum–Unit Price Proposal Procedure in Repair-Renovation Tenders",
    venue: "MAS Journal of Applied Sciences, 6(1), 186–193",
    doi: "10.52520/masjaps.70",
  },
  {
    year: "2021", type: "Tez",
    title: "Evaluation of the design results according to nonlinear static push-up analysis of two reinforced concrete structures with different floor quantities within the scope of TBDY 2019",
    venue: "Yüksek Lisans Tezi – İstanbul Aydın Üniversitesi",
    doi: "",
  },
];

export const QUICK_LINKS = [
  { label: "Anasayfa", href: "#top" },
  { label: "Kurumsal İş Yönetimi", href: "#moduller" },
  { label: "Yayınlarım", href: "#yayinlar" },
];

export const CONTACT_EMAIL = "turna.cagatay@gmail.com";

// Sosyal medya bağlantıları
export const SOCIAL_LINKS = [
  { label: "Instagram", handle: "@cgtytrn",        href: "https://www.instagram.com/cgtytrn",         icon: "instagram" },
  { label: "LinkedIn",  handle: "cagatayturna",    href: "https://www.linkedin.com/in/cagatayturna", icon: "linkedin" },
];
